// GA4 (G-8X289S73CN) — loads ONLY after cookie consent is granted.
// Events: page_view (per route, with language), car_search (first widget
// interaction per page), affiliate_click + discovercars_click (outbound to DC).
// No personal data is sent to Google Analytics.
import { channelForPath } from "../data";

export const GA_MEASUREMENT_ID = "G-8X289S73CN";

let gaLoaded = false;

export const hasAnalyticsConsent = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem("bc-consent") === "granted";

export function initAnalytics() {
  if (gaLoaded || !hasAnalyticsConsent()) return;
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID.includes("XXXX")) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path, title, language) {
  if (!gaLoaded || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    language,
    channel: channelForPath(path),
  });
}

export function trackEvent(name, params = {}) {
  if (!gaLoaded || !window.gtag) return;
  window.gtag("event", name, params);
}

// Outbound affiliate click tracking (does not interfere with DC attribution)
export function bindAffiliateClickTracking() {
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      try {
        const url = new URL(a.href, window.location.origin);
        if (url.hostname.endsWith("discovercars.com")) {
          const path = window.location.pathname;
          const params = {
            page_path: path,
            language: path.startsWith("/it") ? "it" : "en",
            channel: channelForPath(path),
            outbound_url: url.origin + url.pathname,
          };
          trackEvent("affiliate_click", params);
          trackEvent("discovercars_click", params);
        }
      } catch {
        /* ignore */
      }
    },
    true
  );
}
